import { Box, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import React from "react";
import { InputPropsTypes } from "./types/inputTypes";

interface TextFieldInputProps {
  textDesc: string;
  placeholder: string;
  isRequired?: boolean;
  type?: "text" | "password";
  name: string;
  inputProps: InputPropsTypes;
  isPassword?: boolean;
}

const TextFieldNoLabel: React.FC<TextFieldInputProps> = ({
  textDesc,
  placeholder,
  isRequired = false,
  type = "text",
  inputProps,
  name,
  isPassword = false,
}: TextFieldInputProps) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const handleTogglePassword = () => setShowPassword((show) => !show);

  return (
    <Box>
      <Typography color="text.primary" mb={0.5}>
        {textDesc}
        {isRequired && "*"}
      </Typography>
      <TextField
        value={inputProps.value}
        onChange={inputProps.onChange}
        type={isPassword && !showPassword ? "password" : "text"}
        fullWidth
        name={name}
        placeholder={placeholder}
        error={inputProps.error}
        helperText={inputProps.helperText}
        slotProps={{
          input: {
            sx: { bgcolor: "#ffffff" },
            endAdornment: isPassword && (
              <InputAdornment position="end">
                <IconButton onClick={handleTogglePassword} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
};

export default TextFieldNoLabel;
